export default __webpack_public_path__ + "static/media/interior-wipe.3b705021.jpg";